(() => {
  function initialise() {
    const dialog = document.querySelector('.rbs-picker');
    if (!dialog || dialog.dataset.ready) return;
    dialog.dataset.ready = 'true';
    let opener;
    document.querySelectorAll('[data-sport-model]').forEach(button => {
      button.addEventListener('click', () => {
        const template = Array.from(document.querySelectorAll('template[data-sport-options]')).find(item => item.dataset.sportOptions === button.dataset.sportModel);
        if (!template) return;
        opener = button;
        dialog.querySelector('h2').textContent = button.dataset.sportModel;
        const options = dialog.querySelector('.rbs-picker__options');
        options.replaceChildren(template.content.cloneNode(true));
        if (!options.children.length) options.textContent = 'Please call 0800 101 879 to check colours for this size.';
        dialog.showModal();
      });
    });
    dialog.querySelector('.rbs-picker__close').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => opener?.focus({ preventScroll: true }));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise);
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();
